// 乐聊系统资源位打点
import posthog from '@leyan/lytics';

// AppHeader 福利中心
export const buryAppHeaderGiftIcon = () => {
  posthog.capture('$view_welfare_center', {
    source: 'app-header',
    action: 'click-icon',
  });
};

export const buryAppHeaderDropdownMore = () => {
  posthog.capture('$view_welfare_center', {
    source: 'app-header',
    action: 'click-more',
  });
};

export const buryAppHeaderDropdownItem = (url: string) => {
  const regex = /fett-public\/([0-9a-zA-Z]+)/;
  const match = url.match(regex);
  if (match) {
    posthog.capture('$view_welfare_center', {
      source: 'app-header',
      action: 'click-item',
      symbol: match[1],
    });
  }
};

export const buryServiceMarket = () => {
  posthog.capture('$view_welfare_center', {
    source: 'service-market',
    action: 'click-tab',
  });
};

export const buryServiceMarketCarousel = (url: string) => {
  const regex = /fett-public\/([0-9a-zA-Z]+)/;
  const match = url.match(regex);
  if (match) {
    posthog.capture('$view_welfare_center', {
      source: 'service-market',
      action: 'click-carousel-item',
      symbol: match[1],
    });
  }
};

export const buryNoticeBell = () => {
  posthog.capture('$view_notice', {
    action: 'click-icon',
  });
};

export const buryNoticeItem = (properties: Record<string, any>) => {
  posthog.capture('$view_notice', {
    action: 'click-item',
    ...properties,
  });
};

export const buryManual = () => {
  posthog.capture('$view_manual', {
    source: 'app-header',
  });
};

export const buryAppCenter = () => {
  posthog.capture('$view_welfare_center', {
    source: 'app-center',
    action: 'click-tab',
  });
};

export const buryAppCenterCard = (symbol: string, button: 'detail' | 'reg') => {
  posthog.capture('$view_welfare_center', {
    source: 'app-center',
    action: 'click-card',
    symbol,
    button,
  });
};
